import moment from "moment";
import { createAccountVoucherData } from "../../api/restApi";

//  create voucher class
export const VoucherItemType = {
  debit: "Debit",
  credit: "Credit",
};
export const VoucherType = {
  expense: "EXPENSE",
  cashPayment: "CPV",
  bankPayment: "BPV",
  cashReceived: "CRV",
  bankReceived: "BRV",
  sale: "SALE",
  client: "CLIENT",
  journal: "JOURNAL",
};

export class VoucherItem {
  constructor({ transaction, amount, code, particular, description, type }) {
    this.transaction = transaction;
    this.debit = transaction === "Debit" ? amount : "";
    this.credit = transaction === "Credit" ? amount : "";
    this.amount = amount;
    this.code = code;
    this.particular = particular;
    this.Discription = description;
    this.cheque = "";
    this.billno = "";
    this.transactionType = transaction;
    this.type = type;
    this.id = "1";
    this.site = "1";
  }
}
export class Voucher {
  constructor() {
    this.voucherRecBy = "";
    this.voucherDepBy = "";
    this.invoiceBillNum = "";
    this.description = "";
    this.balance = "";
    this.site = "";
    this.voucherItems = [];
    this.amount = "";
    this.voucherDate = moment().utcOffset("+05:00").format("DD/MM/YYYY");
    this.voucherTime = moment().utcOffset("+05:00").format("HH:mm:ss");
    this.voucherMonth = moment().utcOffset("+05:00").format("MM-YYYY");
    this.lockStatus = false;
  }
}
export async function createAccountVoucher(type, voucherItems) {
  let voucher = new Voucher();

  voucher.type = type;
 
  voucher.voucherItems = [...voucherItems];
  await createAccountVoucherData(type, voucher);
  return "";
}